// src/components/ServerDataExtraction/DataExtractionTips.jsx
import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';

const DataExtractionTips = () => {
  const { language } = useLanguage();
  const isEn = language === 'en';

  const tips = [
    {
      title: isEn ? 'Player Sampling' : 'Выборка игроков',
      desc: isEn
        ? 'Many servers send only a limited sample of online players in handshake ping. Deep query extraction can discover additional players.'
        : 'Многие серверы отправляют только выборку онлайн-игроков. Глубокое сканирование может показать больше.',
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
          <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
          <circle cx="9" cy="7" r="4" />
          <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
          <path d="M16 3.13a4 4 0 0 1 0 7.75" />
        </svg>
      )
    },
    {
      title: isEn ? 'Plugin Detection' : 'Обнаружение плагинов',
      desc: isEn
        ? 'Plugin lists are often hidden or protected. Tab-completion inspection helps reveal Bukkit, Paper, and BungeeCord add-ons.'
        : 'Списки плагинов часто скрыты. Успех зависит от конфигурации сервера и открытости tab-completion.',
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
          <rect width="18" height="18" x="3" y="3" rx="2" />
          <path d="m9 8 6 4-6 4Z" />
        </svg>
      )
    },
    {
      title: isEn ? 'Timeout Settings' : 'Настройки таймаута',
      desc: isEn
        ? 'Increase timeout for high-latency servers or proxy chains like Cloudflare Spectrum and TCP reverse proxies.'
        : 'Увеличьте таймаут для медленных серверов, но будьте осторожны с защитными экранами и фильтрами.',
      icon: (
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="10" />
          <polyline points="12 6 12 12 16 14" />
        </svg>
      )
    }
  ];

  return (
    <section className="pro-tips-section">
      <div className="pro-tips-heading">
        <svg viewBox="0 0 24 24" fill="none" strokeWidth="1.8">
          <circle cx="12" cy="12" r="10" />
          <circle cx="12" cy="12" r="3" fill="currentColor" />
        </svg>
        <span>
          {isEn
            ? 'SERVER DATA EXTRACTION ADVICE • PRO TIPS'
            : 'СОВЕТЫ ПО ИЗВЛЕЧЕНИЮ ДАННЫХ СЕРВЕРА • PRO TIPS'}
        </span>
      </div>

      <div className="tips-grid">
        {tips.map((tip, idx) => (
          <div key={idx} className="tip-card">
            {/* Фоновая векторная иконка за плашкой */}
            <div className="tip-backdrop-icon" aria-hidden="true">
              {tip.icon}
            </div>

            <div className="tip-card-inner">
              <div className="tip-icon-header">
                {tip.icon}
              </div>
              <h4 className="tip-title">{tip.title}</h4>
              <p className="tip-description">{tip.desc}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default DataExtractionTips;
